module.exports = __webpack_public_path__ + "static/media/img-talent-app-interview-reminding.f63bc6ab.png";